import { CalendarClock, History } from "lucide-react";
import { tx } from "@/i18n";

const scrollTo = (id) => setTimeout(() => {
  const el = document.getElementById(id);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
}, 50);

export const HistoryJumpBar = ({ count, upcomingId, historyId, onOpenHistory, testPrefix }) => {
  if (!count) return null;
  const btn = "inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors";
  return (
    <div className="sticky top-16 lg:top-0 z-30 -mx-1 px-1 py-2 bg-background/85 backdrop-blur" data-testid={`${testPrefix}-jump-bar`}>
      <div className="inline-flex gap-1 p-1 rounded-full border border-border bg-card shadow-sm">
        <button type="button" onClick={() => scrollTo(upcomingId)} className={`${btn} hover:bg-accent`} data-testid={`${testPrefix}-jump-upcoming`}>
          <CalendarClock className="h-4 w-4" /> {tx("Vanaf vandaag")}
        </button>
        <button type="button" onClick={() => { onOpenHistory(); scrollTo(historyId); }} className={`${btn} hover:bg-accent text-muted-foreground`} data-testid={`${testPrefix}-jump-history`}>
          <History className="h-4 w-4" /> {tx("Historie")} <span className="text-xs">({count})</span>
        </button>
      </div>
    </div>
  );
};
